import { connect } from 'react-redux';
import { reduxForm, change, SubmissionError } from 'redux-form';
import TwoFactorAuthModal from './TwoFactorAuthComponent';
import modalDecorator from '../../hocs/modalDecorator';
import { MODAL_TYPES } from '../../redux/actions/modalActions';
import get from 'lodash/get';
var containerForm = connect(function (state) {
  return {
    TFaType: get(state, 'user.userConfig', []).find(function (i) {
      return i.Value === '2FAType';
    })
  };
})(reduxForm({
  form: 'CONFIRM_2FA',
  onSubmit: function onSubmit(formValues, dispatch, ownProps) {
    var apiCall = ownProps.apiCall,
      apiPayload = ownProps.apiPayload,
      TfaType = ownProps.TfaType,
      close = ownProps.close,
      resolve = ownProps.resolve;
    return apiCall({
      TfaType: get(TfaType, 'Value', 'Google'),
      TFaCode: formValues.code,
      Payload: apiPayload
    }).then(function (response) {
      var data = JSON.parse(response.o);
      if (data && data.TFaAuthenticated === false) {
        throw new SubmissionError({
          _error: data.errMsg
        });
      }
      close();
      return resolve(data);
    });
  },
  onChange: function onChange(values, dispatch, props) {
    if (values.code && values.code.length === 6) {
      props.submit();
    }
  }
})(TwoFactorAuthModal));
var container = connect(null, {
  changeFieldValue: change
})(containerForm);
export default modalDecorator({
  name: MODAL_TYPES.REQUIRE_2FA
})(container);